// those are SVG paths that are required by mdi <Icon> component

export const DoesNotContain =
  'M2 3H8V5H4V19H8V21H2V3ZM22 3V21H16V19H20V5H16V3H22Z M18 7.20857L16.7914 6L12 10.7914L7.20857 6L6 7.20857L10.7914 12L6 16.7914L7.20857 18L12 13.2086L16.7914 18L18 16.7914L13.2086 12L18 7.20857Z';
export const DoesNotEndWith =
  'M22 3V21H16V19H20V5H16V3H22Z M18 7.20857L16.7914 6L12 10.7914L7.20857 6L6 7.20857L10.7914 12L6 16.7914L7.20857 18L12 13.2086L16.7914 18L18 16.7914L13.2086 12L18 7.20857Z';
export const DoesNotStartWith =
  'M2 3H8V5H4V19H8V21H2V3Z M18 7.20857L16.7914 6L12 10.7914L7.20857 6L6 7.20857L10.7914 12L6 16.7914L7.20857 18L12 13.2086L16.7914 18L18 16.7914L13.2086 12L18 7.20857Z';
